import { FoundationElement } from '@microsoft/fast-foundation';
import { ChameleonElementMixin } from '../../common/mixin';
import { html } from '@microsoft/fast-element';
export const templateDataTableBodyV2 = html `<template role="rowgroup"><slot></slot></template>`;
export class DataTableBodyV2Component extends ChameleonElementMixin(FoundationElement) {
}
